var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileError = function SvgFileError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F65050",
    d: "M6.875 1A1.88 1.88 0 0 0 5 2.875v26.25A1.88 1.88 0 0 0 6.875 31h18.75a1.88 1.88 0 0 0 1.875-1.875V7.977L20.459 1H6.875Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B41919",
    d: "M22.108 7.977H27.5L20.469 1v5.312c0 .976.65 1.665 1.639 1.665Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M16.25 12.25c-.69 0-1.25.56-1.25 1.25v5.648a1.25 1.25 0 1 0 2.5 0V13.5c0-.69-.56-1.25-1.25-1.25Zm0 10a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Z",
    clipRule: "evenodd"
  })));
};
export default SvgFileError;